module.exports = __webpack_public_path__ + "media/images/design/images/dantai/DSC_1224_00036-d5fb897d966f3a1115c67c9a5d3f47d8.jpg";